import { Injectable } from '@angular/core';
import { ITerminologyService } from 'terminology-lib';

@Injectable({ providedIn: 'root' })
export class InveniasTerminologyService implements ITerminologyService {
  get name(): string {
    return 'Invenias';
  }

  get anarthrous(): string {
    return 'an';
  }

  get recordName(): string {
    return 'record';
  }

  get recordNamePlural(): string {
    return 'records';
  }

  get recordAnarthrous(): string {
    return 'a';
  }

  get recipientType(): string {
    return 'Person';
  }

  get fileType(): string {
    return 'Document';
  }
}
